module.exports = __webpack_public_path__ + "static/media/logo2026.7fb52850.png";